module.exports = __webpack_public_path__ + "img/6.cc4ee787.svg";